import moment from "moment";
import modelBaseV2 from "../model-base-v2.model";

const ACTION = {
  INSERT: "INSERT",
  UPDATE: "UPDATE",
  DELETE: "DELETE",
};

const EdiManagementSiteMappingModel = {
  getCustomers: () => {
    return modelBaseV2.get("/api/intf-edi/customers");
  },

  search: (queries) => {
    return modelBaseV2.get("/api/intf-edi/siteMapping/search", {
      params: queries,
    });
  },

  on: (action, data) => {
    return modelBaseV2.post("/api/intf-edi/siteMapping/manage", {
      body: { ...data, action },
    });
  },

  add: (newItem) => {
    return EdiManagementSiteMappingModel.on(ACTION.INSERT, newItem);
  },

  update: (item) => {
    return EdiManagementSiteMappingModel.on(ACTION.UPDATE, item);
  },

  delete: (item) => {
    return EdiManagementSiteMappingModel.on(ACTION.DELETE, item);
  },

  downloadTemplate: () => {
    const downloadConfig = {
      storedProcedureCode: "50",
      params: [],
      excelSheetNames: ["INTFSiteMapping"],
    };

    return modelBaseV2.postDownload(
      "/api/executesp/export/commonexcel",
      {
        body: downloadConfig,
      },
      "INTFSiteMapping_template"
    );
  },

  uploadExcel: (formData) => {
    return modelBaseV2.postDownload(
      "/api/intf-edi/SiteMapping/excelUpload",
      {
        body: formData,
      },
      `EDI_Management_Site_Mapping_Uploaded_Result_${moment().format(
        "YYYYMMDDhhmm"
      )}.xlsx`
    );
  },

  downloadSearchResultToExcel: (body) => {
    const paramsMapping = {
      orderBy: "2",
      pageIndex: "3",
      pageSize: "4",
      inputUserID: "7",
      inputCountryCode: "16",
      inputUserLanguageCode: "17",
      sortBy: "24",
      mapType: "80",
      customerCode: "81",
      mapKey: "82",
      mapAttribute1: "83",
      mapAttribute2: "84",
    }

    const params = Object.entries(paramsMapping).map(([key, value]) => {
      let arg = body[key];
      return {
        code: value,
        value: arg
          ? Array.isArray(arg)
            ? arg.join('^')
            : arg.toString()
          : ""
      }
    })

    const exportConfig = {
      excelSheetNames: [
        "INTFSiteMapping"
      ],
      storedProcedureCode: "51",
      params
    }

    return modelBaseV2.postDownload('/api/executesp/export/file', { body: exportConfig }, `EDI_Management_Site_Mapping_${moment().format('YYYYMMDDhhmm')}.xlsx`);
  }
};

export default EdiManagementSiteMappingModel;
